<template>
  <div>    
    <a-row v-if="search">
      <a-col :span="24" class="search-col">
        <a-row>
          <a-col :span="3" class="label">
            选择分中心：
          </a-col>   
          <a-col :span="21">         
            <a-checkbox-group v-model="centerIdList" style="width: 100%" class="info-row">
              <a-row>
                <a-col :span="6" v-for="(item,index) in centerList" :key="index">
                  <a-checkbox :value="item.value">
                    {{item.text}}
                  </a-checkbox>
                </a-col>
              </a-row>
            </a-checkbox-group>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="mini?12:8" class="search-col ">
        <a-row>
          <a-col :span="6" class="label">
            注册日期：
          </a-col>
          <a-col :span="18">
            <a-date-picker value-format='YYYY-MM-DD' v-model="queryParam.startCreateTime" />
            ~
            <a-date-picker value-format='YYYY-MM-DD' v-model="queryParam.endCreateTime" />
          </a-col>
        </a-row>

      </a-col>
      <a-col :span="mini?12:8" class="search-col">
        <a-row>
          <a-col :span="6" class="label">
            通过筛选日期：
          </a-col>
          <a-col :span="18">
            <a-date-picker value-format='YYYY-MM-DD' v-model="queryParam.startPassDate" />
            ~
            <a-date-picker value-format='YYYY-MM-DD' v-model="queryParam.endPassDate" />
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="mini?12:8" class="search-col">
        <a-row>
          <a-col :span="6" class="label">
            <a-select v-model="queryParam.searchType" style="width: 120px">
              <a-select-option :value="item.name" v-for="(item,index) in searchTypeList" :key="index">
                {{item.text}}
              </a-select-option>
            </a-select>
          </a-col>
          <a-col :span="18">
            <a-input v-model="queryParam.searchValue" style="width: 90%"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="mini?12:8" class="search-col ">
        <div style="text-align: left">
          <a-button type="primary" @click="serachMyQuery" style="margin-left: 5px"> 查询</a-button>
          <a-button  @click="searchReset" style="margin-left: 5px"> 重置</a-button>

          <template v-if="exportEmpi">
            <a-upload name="file"
                      style="margin-left: 5px"
                      class="main"
                      :showUploadList="false"
                      :multiple="false"
                      :headers="tokenHeader"
                      :data="{projectId:`${projectId}`}"
                      :action="importExcelUrl"
                      @change="handleImportExcel"
            >
              <a-button type="primary" icon="import">导入交叉索引</a-button>
            </a-upload>
            <a-button  @click="downloadTemplate" style="margin-left: 5px"> 下载导入模版</a-button>
          </template>
          <slot name="btnSelectAll" :data="dataSource"></slot>
        </div>
      </a-col>
    </a-row>
    <a-table rowKey="id"
             size="middle"
             :columns="columns"
             :dataSource="dataSource"
             :pagination="ipagination"
             :loading="loading"
             :scroll="{ x: 1200 }"
             @change="handleTableChange"
             :rowSelection="rowSelection"
    >
            <span slot="action" slot-scope="text, record">
                <a @click="handleSelect(record)">选择</a>
            </span>
      <span slot="status" slot-scope="text, record, index">
            <status-tag :status="text"></status-tag>
           </span>
    </a-table>
  </div>
</template>

<script>
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAction,postAction,putAction, downloadFile} from '@/api/manage'
  import StatusTag from '../StatusTag'
  import { CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  export default {
    name: 'PatientListForExport',
    components: { StatusTag },
    mixins:[JeecgListMixin],
    props:{
      listUrl:{
        type:String,
        default:''
      },
      mini:{
        type:Boolean,
        default:false,
      },
      exportEmpi:{
        type:Boolean,
        default:false,
      },
      search:{
        type:Boolean,
        default:true
      },
      baseParams:{
        type:Object,
        default:()=>{
          return {}
        }
      },
      simple:{
        type:Boolean,
        default:false,
      },
    },
    data(){
      return {
        ipagination:{
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '50','500', '1000'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
        },
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        concernIndicatorList:[],
        trendIndicatorList:[],
        fieldList:[],
        centerIdList:[],
        centerList:[
          // {text:'四川大学华西医院',value:'HX'},
        ],
        baseColumns:[
          {
            title:'受试者编号',
            fixed:'left',
            align: 'center',
            width: 120,
            ellipsis: true,
            dataIndex: 'patientNum'
          },
          {
            fixed:'left',
            title:'EID',
            align: 'center',
            width: 100,
            ellipsis: true,
            dataIndex: 'eid'
          },
          {
            title:'受试者姓名',
            align: 'center',
            fixed:'left',
            width: 120,
            ellipsis: true,
            key: 'name',
            dataIndex: 'name'
          },
          {
            title:'受试者信息',
            children:[
              {
                title:'性别',
                align: 'center',
                width: 80,
                ellipsis: true,
                key: 'sex',
                dataIndex: 'sex_dictText',
              },
              {
                title:'年龄',
                align: 'center',
                width: 80,
                ellipsis: true,
                dataIndex: 'age'
              },

            ]
          },
          {
            title:'入组信息',
            children:[
              {
                title:'研究中心',
                align: 'center',
                width: 100,
                ellipsis: true,
                dataIndex: 'centerName'
              },
              {
                title:'研究员',
                align: 'center',
                width: 100,
                ellipsis: true,
                dataIndex: 'personName'
              },
              {
                title:'状态',
                align: 'center',
                width: 100,
                ellipsis: true,
                scopedSlots: {customRender: 'status'},
                dataIndex: 'status'
              },
              {
                title:'注册日期',
                align: 'center',
                width: 100,
                ellipsis: true,
                dataIndex: 'createTime'
              },
              {
                title:'通过筛选日期',
                align: 'center',
                width: 140,
                ellipsis: true,
                dataIndex: 'passDate'
              },
              {
                title:'组别',
                align: 'center',
                width: 100,
                ellipsis: true,
                dataIndex: 'groupName'
              },
              {
                title:'基点日期',
                align: 'center',
                width: 100,
                ellipsis: true,
                dataIndex: 'baseDate'
              },
            ]
          },
        ],
        url:{
          list:this.listUrl,
        },
        disableMixinCreated:true,
        searchTypeList:[
          {name:'name',text:'受试者姓名'},
          {name:'patient_num',text:'受试者编号'},
          {name:'idcard',text:'身份证号'},
          {name:'eid',text:'EID'},
        ],
      }
    },
    computed:{
      importExcelUrl: function() {
        return `${window._CONFIG['domianURL']}/management/empiPix/importExcel`
      },
      columns(){
        const columns = JSON.parse(JSON.stringify(this.baseColumns))
        if(this.fieldList.length>0){
          this.fieldList.forEach(item=>{
            if(item.type==='2'){
              columns[3].children.push({
                title:item.name,
                align: 'center',
                width: 100,
                ellipsis: true,
                dataIndex:'defineField.'+ item.id
              })
            }
          })
        }
        if(this.concernIndicatorList.length>0){
          this.concernIndicatorList.forEach(item=>{
            columns.push({
              title:item.name,
              align: 'center',
              width: 100,
              ellipsis: true,
              dataIndex: item.id
            })
          })
        }
        columns.push({
          title: '操作',
          dataIndex: 'action',
          width: 100,
          fixed:'right',
          scopedSlots: {customRender: 'action'},
          align: 'center'
        })
        return columns
      },
      rowSelection() {
        return {
          // onChange: (selectedRowKeys, selectedRows) => {
            // console.log(`Selected Row Keys: ${selectedRowKeys}`, 'Selected Rows: ', selectedRows);
            // selectedRows.forEach(item=>{
            //   this.selectionRows.push(item)
            //   this.handleSelect(item)
            // })
          // },
          onSelect: (record, selected, selectedRows) => {
            console.log(`Selected : ${selected}`, 'Selected record: ', record);
            if (!selected) {
              this.onMove(record)
            } else {
              this.handleSelect(record)
            }
          },
          onSelectAll: (selected, selectedRows, changeRows) => {
            console.log(`Selected : ${selected}`, 'selectedRows: ', selectedRows, 'changeRows: ', changeRows);
            if (!selected) {
              changeRows.forEach(item=>{
                this.onMove(item)
              })
            } else {
              selectedRows.forEach(item=>{
                this.handleSelect(item)
              })
            }
          },
        }
      }
    },
    mounted(){
      this.init()
    },
    watch:{
      baseParams:{
        handler:function(){
          this.init()
        },
        deep:true
      }
    },
    methods:{
      handleSelect(record){
        this.$emit('onselect',record)
      },
      onMove(record){
        this.$emit('onmove',record)
      },
      serachMyQuery(){        
        this.$set(this.queryParam,'centerId',this.centerIdList)
        this.searchQuery()
      },
      init(){
        if(this.projectId && !this.simple){
          getAction('/project/projectPatientField/editList',{projectId:this.projectId}).then(res=>{
            if(res.success){
              this.fieldList = res.result
              this.fieldList.forEach(item=>{
                if(item.type==='2'){
                  this.searchTypeList.push({
                    name:item.id,
                    text:item.name
                  })
                }
              })
            }
          })
          getAction('/project/projectConcernIndicator/list',{projectId:this.projectId}).then(res=>{
            if(res.success){
              this.concernIndicatorList=res.result
            }
          })
          getAction('/project/projectTrendIndicator/list',{projectId:this.projectId}).then(res=>{
            if(res.success){
              this.trendIndicatorList=res.result
            }
          })
          // 中心
        getAction('/project/center/listAll',{projectId:this.projectId}).then(res=>{
          if(res.success){
            // const checkedList = []
            const dataList = []
            res.result.forEach(center=>{
              const centerInfo = {
                text:center.center.name,
                value:center.centerId,
              }
              dataList.push(centerInfo)
            })
            this.centerList = dataList            
          }
        })
        }
        this.baseQueryParam = Object.assign({projectId:this.projectId},this.baseParams)
        this.$set(this.queryParam,'searchType','name')
        this.loadData()
      },
      downloadTemplate(){
        downloadFile('/management/empiPix/downloadTemplate','交叉索引导入模版.xlsx')
      }
    }
  }
</script>

<style scoped lang="less">
  .search-col{
    margin-bottom: 10px;
    .label{
      text-align: right;
      padding-right: 10px;
    }
  }
</style>